module.exports = __webpack_public_path__ + "static/7-8e5975d7871ab2c37b8881e97c33932d.jpg";